import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultButton from 'components/Utils/NewDefaultButton';
import DefaultTextField from 'components/Utils/DefaultTextField';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';

const NewDocumentTemplateCategory = (props) => {
  const dispatch = useAppDispatch();

  const [value, setValue] = useState({
    name: '',
    order: undefined,
    collapsed: undefined,
  });
  const [saving, setSaving] = useState(false);

  async function save() {
    setSaving(true);
    let result = await dispatch(
      api.Templates.addDocumentTemplateCategory({ documentTemplateCategory: value }),
      {
        errorTitle: 'Document Template Category',
      },
    );
    setSaving(false);
    if (result) {
      if (props.onClose()) props.onClose();
    }
  }

  function onChange(event) {
    let target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;

    setValue((prevState) => {
      return {
        ...prevState,
        [target.name]: value,
      };
    });
  }

  return (
    <div className="modal add-template-modal">
      <div className="title">Add Document Template Category</div>
      <div className="content padded-box" style={{ height: 'auto' }}>
        <DefaultTextField name="name" value={value.name} onChange={onChange} label="Name" />
      </div>
      <div
        className="buttons"
        style={{
          background: 'white',
          width: '100%',
          padding: '20px',
          boxSizing: 'border-box',
          textAlign: 'center',
        }}
      >
        <DefaultButton
          name="Cancel"
          onClick={props.onClose}
          style={{ marginRight: '10px' }}
          disabled={saving}
        />
        <DefaultButton name="Save" onClick={save} loading={saving} style={{ marginLeft: '10px' }} />
      </div>
    </div>
  );
};

NewDocumentTemplateCategory.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default NewDocumentTemplateCategory;
